
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"32","viewBox":"0 0 32 32","width":"32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.009 2.569c-.247 0-.488.084-.68.24L.4 14.719a.985.985 0 00-.317 1.19.977.977 0 00.945.664h4.019V28.79a.644.644 0 00.638.641h7.024a.638.638 0 00.638-.641v-8.954h5.31v8.954a.644.644 0 00.638.641h7.035a.641.641 0 00.64-.641V16.523h4.016a.986.986 0 00.947-.667.985.985 0 00-.319-1.138L16.685 2.808a1.07 1.07 0 00-.677-.24zm0 1.328l14.225 11.462h-3.901a.65.65 0 00-.641.638v12.155h-5.756v-8.957a.64.64 0 00-.64-.639h-6.587a.65.65 0 00-.641.638v8.957H6.325V15.934a.658.658 0 00-.641-.641H1.783z"}})])
          )
        }
      }
    